import React, { useState, useEffect, useReducer, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  HeaderFilter,
  Scrolling,
  Toolbar,
  Item,
  SearchPanel
} from "devextreme-react/data-grid";
import { isEmpty } from "lodash";
import { CONFIG } from "./config";
import ScrollView from "devextreme-react/scroll-view";
import { alert } from "devextreme/ui/dialog";
import * as utils from "../../common/utils";
import notify from "devextreme/ui/notify";
import FileUploader from "devextreme-react/file-uploader";
import { getTypeOfFile, onDownloadFile } from "../../common/utils";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import WhiteBoard from "../common/WhiteBoard/WhiteBoard";
import { Button } from "devextreme-react/button";
import sa3 from "../../reducers/sa3";
import * as actions from "../../actions/sa3";
import { CheckBox } from "devextreme-react/check-box";
import { confirm } from "devextreme/ui/dialog";
import { RequiredRule } from "devextreme-react/validator";
import { postUserLog } from "../../actions/common";
import { postLogForFilter } from "./utils";
import config from "../../common/config";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../utils/fileValidator";

const initialStates = {
  approvers: [],
  peopleList: [],
  reasonCodes: [],
  rpsRail: [],
};

const RapidExperiment = ({
  a3ID,
  activeAlert,
  siteId,
  data,
  activeItem,
  tierId,
  handleA3Save,
  setisOpen,
  isDataSaved,
  activeTab,
}) => {
  const [state, dispatch] = useReducer(sa3, initialStates);
  const [selectedFiles, setSelectedFiles] = useState([]);
  let wbIs, wbRc;
  const wBRc = (k) => {
    wbRc = k;
  };
  const [WBRc, setWBRc] = useState(false);

  let { rapidExperimentData, attachmentsA3 } = state;

  const [distinctUsers, setDistinctUsers] = useState([]);
  const [image, setImage] = useState(null);
  const [isEnabled, setIsEnabled] = useState(true);

  const [enable, setenable] = useState(false);
  const [enableSave, setEanbleSave] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
  const dataGridRef = useRef(null);

  useEffect(() => {
    utils.set("wbData_rea3", { objects: [] });
    actions.fetchRapidExperimentGridDataa3(dispatch, a3ID);
    actions.GetAttachmentsDataA3(dispatch, a3ID, "Experiment");
  }, []);

  useEffect(() => {
    setGridData(rapidExperimentData?.lsExperiment);
    utils.set(
      "wbData_rea3",
      rapidExperimentData?.experimentWhiteBoard
        ? JSON.parse(rapidExperimentData.experimentWhiteBoard)
        : { objects: [] }
    );
    populateDistinctUsersList();
  }, [rapidExperimentData, enable]);

  useEffect(() => {
    AsyncCallHandler(NEXUS_CONST.FETCH_A3_DATA + a3ID, NEXUS_CONST.GET).then(
      (res) => {
        if (res) {
          if (res && res.data) {
            setEanbleSave(res?.data?.status === "Complete");
            setenable(res?.data?.isRapidExperiment);
          }
        }
      }
    );
  }, []);

  const populateDistinctUsersList = () => {
    let _distinctUsers = [
      ...new Map(
        rapidExperimentData?.lsOwner.map((ele) => [ele["memberID"], ele])
      ).values(),
    ];
    setDistinctUsers([..._distinctUsers]);
  };

  const onRowUpdated = () => {
    setIsEnabled(true);
  };
  const onRowInserted = () => {
    setIsEnabled(true);
  };
  
  const deleteFile = (id,attachmentName) => {
    let confirm_it = confirm(
      "Are you sure you want to delete?",
      "Confirm changes"
    );
    confirm_it.then((res) => {
      actions.deleteAttachmentA3(dispatch, id, a3ID, "Experiment",attachmentName,tierId, activeTab);
    });
  };
  function handleGridOptionChanged(e) {
    postLogForFilter(
      dataGridRef,
      e,
      siteId,
      tierId,
      "Rapid Experiment",
      6,
      a3ID,
      activeTab
    );
  }
  const saveExperiment = () => {
    dataGridRef.current?.instance?.saveEditData();
    setEanbleSave(true);
    let totalFileSize = selectedFiles?.reduce((acc, cur) => {
      return (acc = acc + cur.size);
    }, 0);

    const validateUploadFiles = checkUploadFilesValid(
      selectedFiles,
      ALLOWED_MIME_TYPES
    );

    if (validateUploadFiles.length) {
      const alertMsg = validateUploadFiles.map(
        (file) => `${file.name} - ${file.reason}`
      );
      alert(alertMsg.join("<br/>"), "Alert");
      setEanbleSave(true);
    }

    if (
      (gridData && gridData?.length == 0 && enable == false) ||
      (selectedFiles?.length > 0 && totalFileSize > 4000000)
    ) {
      setEanbleSave(false);
      alert("Please enter value marked mandatory", "Alert");
      return false;
    } else {
      // let wbdata = utils.get('wbData_rc')

      let eperimentWB = utils.get("wbData_rea3")
        ? JSON.stringify(utils.get("wbData_rea3"))
        : { objects: [] };

      let data = {
        a3Id: a3ID,
        isRapidExperiment: enable,
        experimentWhiteBoard: eperimentWB,
        lastSavedTab: "6",
        tierId: tierId,
        lsExperiment: gridData,
        section:activeTab
      };
      AsyncCallHandler(
        NEXUS_CONST.MANAGE_EXPERIMENTS_DATA,
        NEXUS_CONST.POST,
        data
      ).then((res) => {
        if (res) {
          notify("Rapid Experiments got saved successfully!", "success", 500);

          if (selectedFiles?.length === 0) {
            setEanbleSave(false);
          }

          actions.fetchRapidExperimentGridDataa3(dispatch, a3ID);

          handleA3Save();
        }
      });
      if (selectedFiles?.length > 0) {
        let formData = new FormData();
        if (
          selectedFiles &&
          selectedFiles.length &&
          Array.isArray(selectedFiles)
        ) {
          selectedFiles.forEach((file) => {
            formData.append("files", file);
          });
        }
        formData.append("A3Id", a3ID);
        formData.append("TierID", tierId);
        formData.append("attachmentType", "Experiment");
        formData.append("activeTab", activeTab);
        AsyncCallHandler(
          NEXUS_CONST.MANAGE_ATTACHMENT_A3,
          NEXUS_CONST.PUT,
          formData
        ).then((res) => {
          setEanbleSave(false);
          actions.GetAttachmentsDataA3(dispatch, a3ID, "Experiment");
          setSelectedFiles([]);
        });
      }
      isDataSaved(6);
      handleA3Save();
      setisOpen("6");
    }
  };

  const handlers = {
    onRowInserted: onRowInserted,
    onRowUpdated: onRowUpdated
  };

  const onFileSelect = (e) => {
    setSelectedFiles(e.value);
    if (e.value[0] !== undefined) {
      setImage(URL.createObjectURL(e.value[0]));
    }
  };
  const handleWhiteBoard = () => {
    setWBRc(!WBRc);
    postUserLog({
      event: "Box 6 - Rapid Experiment",
      data: {
        action: `Whiteboard selected for A3-${a3ID}`,
        module: "Digital Tier",
        section: activeTab,
        siteUId: siteId,
        widget: "Strategic A3",
        tierId: tierId,
      },
    });
  };

  const onRowValidating = (e) => {
    const requiredFields = [
      "description",
      "expectedResults",
      "dueDate",
      "owner",
    ];
    for (const field of requiredFields) {
      if (!e.newData[field]) {
        e.isValid = false;
        e.errorText = `${field} is required.`;
        break;
      }
    }
  };

  const handleInputChange = (e) => {
    setenable(e.value);
  };
  return (
    <>
      <div className="title-section">
        {" "}
        <h2 className="sps_title">
          <span className="sps-print">Box 6 - &nbsp;</span>Rapid Experiment
        </h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={enableSave}
            width={200}
            onClick={saveExperiment}
            text="Save"
            type="normal"
          />
        </div>
      </div>

      <ScrollView width="100%" height="420px" className="sps-box-s">
        <div className="gridavailable">
          <div>
            <CheckBox
              name="chk"
              value={enable ?? false}
              onValueChanged={handleInputChange}
            />{" "}
            Not applicable
          </div>
          <div>
            <DataGrid
              dataSource={gridData}
              allowColumnReordering={true}
              showBorders={true}
              ref={dataGridRef}
              disabled={enable}
              {...CONFIG.A3_EXPERIMENT}
              {...handlers}
              wordWrapEnabled={true}
              width={"100%"}
              onRowValidating={onRowValidating}
              onOptionChanged={handleGridOptionChanged}
              onExporting={() =>
                postUserLog({
                  event: `Box 6 - Export`,
                  data: {
                    action: `Rapid Experiment exported for A3-${a3ID}`,
                    module: "Digital Tier",
                    section: activeItem,
                    siteUId: siteId,
                    widget: "Strategic A3",
                    tierId: tierId,
                  },
                })
              }
            >
              <Toolbar>
                <Item name="addRowButton" />
                <Item name="columnChooserButton" />
                <Item name="revertButton" />
                <Item name="saveButton" visible={false} />
                <Item name="searchPanel" />
                <Item name="exportButton" />
              </Toolbar>
              <SearchPanel
              visible={true}
              onTextChange={(e) => {
                if (!isEmpty(e)) {
                  postUserLog({
                    event: "Box 6 - Rapid Experiment Grid Search",
                    data: {
                      action: `${e} searched in rapid experiment grid A3-${a3ID}`,
                      module: "Digital Tier",
                      section: activeTab,
                      siteUId: siteId,
                      widget: "Strategic A3",
                      tierId: tierId,
                    },
                  });
                }
              }}
            />
              <Column
                dataField="a3ID"
                caption="A3ID"
                visible={false}
                allowEditing={false}
                minWidth={20}
              ></Column>
              <Column
                dataField="experimentId"
                caption="Rapid Experiment ID"
                visible={false}
                allowEditing={false}
                minWidth={20}
              ></Column>
              <Column
                dataField="description"
                caption="Experiment Description"
                visible={true}
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              >
                <RequiredRule />
              </Column>
              <Column
                dataField="expectedResults"
                caption="Expected Results"
                visible={true}
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              >
                <RequiredRule />
              </Column>

              <Column
                dataField="dueDate"
                caption="Due Date"
                dataType="date"
                width={110}
                minWidth={20}
              >
                <RequiredRule />
              </Column>
              <Column
                dataField="actualResults"
                caption="Actual Results"
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              ></Column>
              <Column
                dataField="notes"
                caption="Notes"
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              ></Column>
              <Column
                dataField="followUpActions"
                caption="Follow-up Actions"
                cssClass="WrappedColumn"
                width={200}
                minWidth={20}
              ></Column>
              <Column dataField="owner" caption="Owner" minWidth={20}>
                <Lookup
                  dataSource={distinctUsers}
                  valueExpr="memberID"
                  displayExpr="memberName"
                />
                <RequiredRule />
              </Column>
            </DataGrid>
          </div>

          {config.DEV_DISPLAY_OPTIONS && <div className="wb-act-blk no-print">
            <Button
              className="rps-wb-btn"
              type="normal"
              disabled={enable}
              onClick={handleWhiteBoard}
            >
              <span className="icon whiteboard wh-50"></span>
            </Button>
          </div> }
          {
            <>
              {config.DEV_DISPLAY_OPTIONS && WBRc && (
                <div>
                  <WhiteBoard
                    siteId={siteId}
                    isRps={true}
                    wbRef={wBRc}
                    rpsData={utils.get("wbData_rea3")}
                    widgetId={"rea3"}
                  />
                </div>
              )}
            </>
          }
          <div
            className="dx-field no-print"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="dx-field-label">Rapid Experiment Attachment</div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {activeAlert?.imageName && (
                <div>
                  <a
                    style={{ cursor: "pointer" }}
                    className="clickable-hover"
                    onClick={() => {
                      getTypeOfFile(
                        {
                          imageName: activeAlert.imageName,
                          fileExtension: activeAlert?.imageName.split(".")[1],
                        },
                        "Sites"
                      );
                    }}
                  >
                    {" "}
                    {activeAlert?.imageName}
                  </a>
                  &nbsp; &nbsp;&nbsp;
                  {(activeAlert.imageName != "DELETED" || "") && (
                    <>
                      {" "}
                      <i
                        title="Delete"
                        className="fas fa-trash pointer"
                        onClick={(e) => deleteFile(e)}
                      ></i>
                      &nbsp; &nbsp;&nbsp;
                      <i
                        title="Download"
                        className="fa fa-download pointer"
                        onClick={() =>
                          onDownloadFile(activeAlert?.imageName, "Sites")
                        }
                      ></i>
                    </>
                  )}
                </div>
              )}
              {(!activeAlert?.imageName ||
                activeAlert?.imageName == "DELETED" ||
                "") && (
                // <FileUploader
                //   className="dx-field-value"
                //   selectButtonText="Choose file"
                //   labelText="Max. File Size 4 MB"
                //   accept="*"
                //   uploadMode="useForm"
                //   disabled={enable}
                //   multiple={true}
                //   onValueChanged={onFileSelect}
                //   value={selectedFiles}
                // />
                <FileUploader
                  className="dx-field-value gridavailable"
                  selectButtonText="Choose file"
                  labelText="Max. File Size 4 MB"
                  accept="*"
                  uploadMode="uploadUrl"
                  disabled={enable}
                  multiple={true}
                  onValueChanged={onFileSelect}
                  value={selectedFiles}
                  allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
                />
              )}
            </div>
          </div>
          <div className="no-print">
            {attachmentsA3 &&
              attachmentsA3.map((item) => (
                <div>
                  <a
                    style={{ cursor: "pointer" }}
                    className="clickable-hover"
                    onClick={() => {
                      onDownloadFile(
                        item?.attachmentName,
                        "StratagicA3",
                        "Experiment"
                      );
                    }}
                  >
                    {" "}
                    {item?.attachmentName}{" "}
                  </a>
                  <span className="rca_download">
                    <i
                      title="Download"
                      className="fa fa-download pointer"
                      onClick={() =>
                        onDownloadFile(
                          item?.attachmentName,
                          "StratagicA3",
                          "Experiment"
                        )
                      }
                    ></i>
                  </span>
                  <span
                    className="rca_delete"
                    style={{ padding: "0px 15px 0px 10px" }}
                  >
                    <i
                      title="Delete"
                      className="fas fa-trash pointer"
                      onClick={() => deleteFile(item.id,item.attachmentName)}
                    ></i>
                  </span>
                </div>
              ))}
          </div>
        </div>
      </ScrollView>
    </>
  );
};
export default RapidExperiment;
